// @file Network requests related to Whiteboard Sound Effects

import { getHyphenatedCurrentLocale } from '@@/bits/current_locale'
import type { VersionedFetchOptions } from '@@/surface/api/fetchable_object'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { WhiteboardSoundEffect } from '@@/types'
import type { JsonAPIResponse } from '@padlet/arvo'
import { HTTPMethod } from '@padlet/fetch'
import { type FetchOptionQueryHash } from '@padlet/fetch/src/types'

class WhiteboardSoundEffectsApi extends FetchableObject {
  public static get url(): string {
    return `/api/\${ apiVersion }/whiteboard/sound-effects`
  }

  public static async fetch(
    query: { ids?: string[] } = {},
    fetchOptions: VersionedFetchOptions = { apiVersion: 1 },
  ): Promise<WhiteboardSoundEffect[]> {
    const queryParams: FetchOptionQueryHash = { locale: getHyphenatedCurrentLocale() }
    if (query.ids != null && query.ids.length > 0) {
      queryParams.ids = query.ids.join(',')
    }
    const { apiVersion = 1, ...otherFetchOptions } = fetchOptions
    const response: JsonAPIResponse<WhiteboardSoundEffect> = await fetchJson(this.buildUrl(this.url, { apiVersion }), {
      method: HTTPMethod.get,
      ...otherFetchOptions,
      query: queryParams,
    })
    const data = Array.isArray(response.data) ? response.data : [response.data]
    return data.map((e) => e?.attributes).filter(Boolean) as WhiteboardSoundEffect[]
  }
}

export { WhiteboardSoundEffectsApi }
